// ─────────────────────────────────────────────────────────────
//  Phoenix Kabob — Pricing Configuration
// ─────────────────────────────────────────────────────────────

export const DELIVERY_FEE = 5;
export const FREE_DELIVERY_THRESHOLD = 40;

// Arizona TPT — Surprise AZ rate
export const TAX_RATE = 0.091;

export const ADDONS = [
  {
    id: 'garlic_sauce',
    name: 'Garlic Sauce',
    price: 1.50,
    image: '/images/garlic-sauce.png',
    description: 'House-made creamy garlic sauce',
  },
  {
    id: 'ranch',
    name: 'Homemade Ranch',
    price: 1.50,
    image: '/images/ranch.png',
    description: 'Fresh homemade buttermilk ranch',
  },
  {
    id: 'pita',
    name: 'Pita Bread',
    price: 1.00,
    image: '/images/pita.png',
    description: 'Warm, fresh-baked pita bread',
  },
  {
    id: 'faygo',
    name: 'Faygo Pop',
    price: 1.50,
    image: '/images/faygo.png',
    description: 'Choose your favorite Faygo flavor',
  },
  {
    id: 'extra_skewer',
    name: 'Extra Skewer',
    price: 5.00,
    image: '/images/extra-skewer.png',
    description: 'Add an extra kofta kabob skewer',
  },
];
